<template>
    <b-alert show :variant="variant" class="text-center">
        <h5 class="alert-heading">Уровень функциональной подготовленности</h5>
        <h6>{{ Math.abs(coeff).toFixed(2) }} </h6>
        <h6 class="alert-heading">{{ msg }}</h6>
    </b-alert>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            coeff: {
                type: Number,
                default: 0,
            }
        },
        computed: {
            msg: function () {
                return this.find().msg;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: [
                    {
                        is: function (x) {
                            return x >= 4.25;
                        },
                        msg: 'Превосходный',
                        variant: 'success'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 3.25, 4.25);
                        },
                        msg: 'Высокий',
                        variant: 'warning'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 2.25, 3.25);
                        },
                        msg: 'Средний',
                        variant: 'primary'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 1.25, 2.25);
                        },
                        msg: 'Недостаточный',
                        variant: 'danger'
                    },
                    {
                        is: function (x) {
                            return x < 1.25;
                        },
                        msg: 'Неудовлетворительный',
                        variant: 'dark'
                    }
                ]
            }
        },
        methods: {
            find() {
                let vm = this;
                return _.find(this.display, function (d) {
                    return d.is(vm.coeff);
                });
            }
        }
    }
</script>